import React, { useState,useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useManualSelectionStore from '../stores/manualSelectionStore';
import StatusBar from '../components/StatusBar';
import SelectionModal from '../components/SelectionModal';
import NumberAdjuster from '../components/NumberAdjuster';
import { initSpeechSynthesis, playWord } from '../utils/speechService'; // 导入公共语音服务
import { useSettings } from '../hooks/useSettings'; // 导入全局设置钩子

const ManualSelection = () => {
  const navigate = useNavigate();
    // 获取全局设置
    const { settings, previewVoice } = useSettings();
  const {
    grade, term, multiSelectMode, selectedUnits, availableUnits,
    words, dictationSettings: pageSettings, modal, modalOptions,
    toggleUnit, clearSelectedUnits, selectAllUnits,
    toggleWord, selectAllWords,
    toggleRandomOrder,
    openModal, closeModal, setGrade, setTerm, toggleMultiSelectMode
  } = useManualSelectionStore();

  // 添加单词筛选状态
  const [filterUnit, setFilterUnit] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);

    // 合并全局设置和页面特定设置
  // 本地听写设置状态，初始值从全局设置获取
  const [localSettings, setLocalSettings] = useState({
    repeatCount: settings.repeatCount || 3,
    repeatInterval: settings.repeatInterval || 3,
    wordInterval: settings.wordInterval || 5,
    randomOrder: pageSettings.randomOrder || false
  });

    // 当全局设置变化时，更新本地设置的初始值
    useEffect(() => {
      setLocalSettings(prev => ({
        ...prev,
        repeatCount: settings.repeatCount || prev.repeatCount,
        repeatInterval: settings.repeatInterval || prev.repeatInterval,
        wordInterval: settings.wordInterval || prev.wordInterval
      }));
    }, [settings]);
  
    // 处理本地设置变化
    const handleSettingChange = (key, value) => {
      setLocalSettings(prev => ({
        ...prev,
        [key]: value
      }));
    };
  // 计算已选单词数量
  const selectedWordsCount = words.filter(word => word.selected).length;
  
  // 计算已选单词来自的单元数量
  const selectedUnitsFromWords = [...new Set(
    words.filter(word => word.selected).map(word => word.unit)
  )].length;

  // 获取当前模态框的选项和选中值
  const getModalProps = () => {
    switch (modal.type) {
      case 'grade':
        return {
          title: '选择年级',
          options: modalOptions.grade,
          selectedOption: grade,
          onSelect: setGrade
        };
      case 'term':
        return {
          title: '选择学期',
          options: modalOptions.term,
          selectedOption: term,
          onSelect: setTerm
        };
      case 'mode':
        return {
          title: '选择模式',
          options: modalOptions.mode,
          selectedOption: multiSelectMode ? '多选模式' : '单选模式',
          onSelect: (option) => toggleMultiSelectMode(option === '多选模式')
        };
      default:
        return {
          title: '',
          options: [],
          selectedOption: '',
          onSelect: () => {}
        };
    }
  };
// 修改toggleUnit函数，处理单选模式
  const handleToggleUnit = (unit) => {
    if (!multiSelectMode) {
      // 单选模式：清除之前选择，只选择当前单元
      clearSelectedUnits();
    }
    toggleUnit(unit);
  };
  // 筛选单词的函数
  const filteredWords = filterUnit 
  ? words.filter(word => selectedUnits.includes(word.unit) && word.unit === filterUnit)
  : words.filter(word => selectedUnits.includes(word.unit));

    // 修改全选单词的处理函数，只选择已选单元中的单词
    const handleSelectAllWords = () => {
      // 获取已选单元中的所有单词ID
      const selectedUnitWordsIds = words
        .filter(word => selectedUnits.includes(word.unit))
        .map(word => word.id);
      
      // 更新单词选中状态
      const updatedWords = words.map(word => {
        if (selectedUnitWordsIds.includes(word.id)) {
          return { ...word, selected: true };
        }
        return word;
      });
      
      // 更新状态
      selectAllWords(updatedWords);
    };
  // 处理开始听写
  const handleStartDictation = () => {
    // 获取已选中的单词
    let selectedWords = words.filter(word => word.selected);
    
    // 如果没有选择单词，提示用户
    if (selectedWords.length === 0) {
      alert('请至少选择一个单词进行听写');
      return;
    }

    // 如果启用随机顺序，则打乱单词顺序
    if (localSettings.randomOrder) {
      selectedWords = [...selectedWords].sort(() => Math.random() - 0.5);
    }

    // 尝试初始化语音合成系统
    const initialized = initSpeechSynthesis();
    setSpeechInitialized(initialized);
    
    // 准备传递给听写页面的数据
    const dictationData = {
      words: selectedWords,
      bookInfo: {
        grade: grade,
        term: term,
        unit: selectedUnits.join(', ')
      },
      settings: {
        // 使用本地临时设置
        repeatCount: localSettings.repeatCount,
        repeatInterval: localSettings.repeatInterval,
        wordInterval: localSettings.wordInterval,
        randomOrder: localSettings.randomOrder,
        // 使用全局设置中的语音相关设置
        voiceType: settings.voiceType,
        voiceId: settings.voiceId,
        voiceSpeed: settings.voiceSpeed,
        speechInitialized: initialized
      }
    };
    
    console.log("dictationData,", dictationData);
    // 导航到听写页面并传递数据
    navigate('/dictation', { state: dictationData });
  };

  // 添加语音初始化状态
  const [speechInitialized, setSpeechInitialized] = useState(false);

  // 初始化语音合成系统
  useEffect(() => {
    // 检查浏览器是否支持语音合成
    if (window.speechSynthesis) {
      // 尝试获取语音列表，这会初始化语音合成系统
      window.speechSynthesis.getVoices();
    }
  }, []);
  
  // 添加一个测试语音按钮的处理函数
  const handleTestVoice = () => {
    previewVoice('Hello');
  };
  
  // 单元筛选模态框
  const FilterModal = () => (
    <div className={`fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center ${showFilterModal ? 'block' : 'hidden'}`}>
      <div className="bg-white rounded-xl w-11/12 max-w-md">
        <div className="p-4 border-b border-gray-100">
          <h3 className="text-lg font-bold">按单元筛选</h3>
        </div>
        <div className="p-4 max-h-80 overflow-y-auto">
          <div 
            className={`p-3 mb-2 rounded-lg ${filterUnit === null ? 'bg-blue-50 text-blue-700 font-medium' : 'bg-gray-50'}`}
            onClick={() => {
              setFilterUnit(null);
              setShowFilterModal(false);
            }}
          >
            显示全部单元
          </div>
          {selectedUnits.map(unit => (
            <div 
              key={unit}
              className={`p-3 mb-2 rounded-lg ${filterUnit === unit ? 'bg-blue-50 text-blue-700 font-medium' : 'bg-gray-50'}`}
              onClick={() => {
                setFilterUnit(unit);
                setShowFilterModal(false);
              }}
            >
              {unit}
            </div>
          ))}
        </div>
        <div className="p-4 border-t border-gray-100">
          <button 
            className="w-full py-2 bg-gray-100 rounded-lg font-medium"
            onClick={() => setShowFilterModal(false)}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#f9f9f9] text-[#333]">
      {/* Main Content */}
      <div className="p-5">
        {/* Navigation Header */}
        <div className="flex justify-between items-center mb-6">
          <Link to="/" className="text-blue-500">
            <i className="fa-solid fa-chevron-left mr-1"></i>
            返回
          </Link>
          <h2 className="text-xl font-bold">手动选择</h2>
          <div className="w-16"></div> {/* Spacer for alignment */}
        </div>

        {/* Textbook Unit Selection */}
        <div className="mb-6">
          <h3 className="font-bold text-lg mb-3">选择课本单元</h3>
          <div className="bg-white rounded-xl shadow-sm mb-3">
            <div 
              className="p-3 border-b border-gray-100 flex justify-between items-center"
              onClick={() => openModal('grade')}
            >
              <div className="font-medium">年级</div>
              <div className="flex items-center text-gray-600">
                <span>{grade}</span>
                <i className="fa-solid fa-chevron-right ml-2 text-xs text-gray-400"></i>
              </div>
            </div>
            <div 
              className="p-3 border-b border-gray-100 flex justify-between items-center"
              onClick={() => openModal('term')}
            >
              <div className="font-medium">学期</div>
              <div className="flex items-center text-gray-600">
                <span>{term}</span>
                <i className="fa-solid fa-chevron-right ml-2 text-xs text-gray-400"></i>
              </div>
            </div>
            <div 
              className="p-3 flex justify-between items-center"
              onClick={() => openModal('mode')}
            >
              <div className="font-medium">单元选择</div>
              <div className="flex items-center text-blue-500">
                <span>{multiSelectMode ? '多选模式' : '单选模式'}</span>
                <i className="fa-solid fa-chevron-right ml-2 text-xs text-gray-400"></i>
              </div>
            </div>
          </div>
          {/* 单元选择列表 */}
          <div className="bg-white rounded-xl shadow-sm p-3">
          <div className="flex justify-between items-center mb-2">
            <h4 className="font-medium">选择单元</h4>
            <button 
              className="text-xs text-blue-500"
              onClick={selectAllUnits}
            >
              全选
            </button>
          </div>
          <div className="grid grid-cols-3 gap-2">
            {availableUnits.map((unit) => {
              const isSelected = selectedUnits.includes(unit);
              return (
                <div 
                  key={unit}
                  className={`border ${isSelected ? 'border-blue-500 bg-blue-50 text-blue-700 font-medium' : 'border-gray-200 text-gray-700'} rounded-lg p-2 text-center text-sm cursor-pointer`}
                  onClick={() => handleToggleUnit(unit)}
                >
                  {unit}
                </div>
              );
            })}
          </div>
        </div>
        </div>

        {/* Word Selection */}
        <div className="mb-6">
          <div className="flex justify-between items-center mb-3">
            <h3 className="font-bold text-lg">选择单词</h3>
            <div>
              <button 
                className="text-blue-500 text-sm font-medium mr-2"
                onClick={handleSelectAllWords}
              >
                全选
              </button>
              <button 
                className="bg-blue-50 text-blue-600 text-sm font-medium px-2 py-1 rounded-md"
                onClick={() => setShowFilterModal(true)}
              >
                按单元筛选 <i className="fa-solid fa-filter ml-1 text-xs"></i>
              </button>
            </div>
          </div>
          
          <div className="bg-white rounded-xl p-4 shadow-sm mb-3">
            {/* 单元标签 */}
            <div className="mb-3 pb-3 border-b border-gray-100">
              <div className="flex justify-between">
                <span className="text-sm font-medium text-gray-600">单词来源：</span>
                {filterUnit && (
                  <span className="text-sm text-blue-600">
                    当前筛选: {filterUnit}
                    <button 
                      className="ml-1 text-xs text-gray-400"
                      onClick={() => setFilterUnit(null)}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </span>
                )}
              </div>
              <div className="flex flex-wrap gap-1 mt-1">
              {selectedUnits.map((unit) => {
                  // 从 words 数组中找到对应单元的颜色
                  const unitColor = words.find(word => word.unit === unit)?.color || 'blue';
                  return (
                    <div key={unit} className={`bg-white px-3 py-1 rounded-full text-xs border border-${unitColor}-200 text-${unitColor}-700 flex items-center`}>
                      <span>{unit}</span>
                      <button 
                        className={`ml-1 text-${unitColor}-400`}
                        onClick={() => toggleUnit(unit)}
                      >
                        <i className="fa-solid fa-xmark text-xs"></i>
                      </button>
                    </div>
                  );
                })}
              </div>
            </div>
            
    {/* 单词选择部分 - 更新为显示更多单词信息 */}
    <div className="grid grid-cols-1 gap-2">
      {filteredWords.map((word) => (
        <div 
          key={word.id}
          className={`border rounded-lg p-3 flex justify-between items-center ${
            word.selected ? `bg-${word.color}-50 border-${word.color}-300` : 'border-gray-200'
          }`}
          onClick={() => toggleWord(word.id)}
        >
          <div className="flex flex-col">
            <div className="flex items-center">
              <span className={`font-medium ${word.selected ? `text-${word.color}-700` : 'text-gray-800'}`}>
                {word.word}
              </span>
              {word.phonetic && (
                <span className="text-xs text-gray-500 ml-2">
                  {word.phonetic}
                </span>
              )}
            </div>
            {word.translation && (
              <span className="text-xs text-gray-500">
                {word.translation} {word.partOfSpeech && `(${word.partOfSpeech})`}
              </span>
            )}
          </div>
          <div className="flex items-center">
            <div className="flex flex-col gap-1 items-center mr-2">
              <span className="text-xs bg-gray-100 px-2 py-1 rounded">
                {word.unit}
              </span>
              <span className="text-xs bg-gray-100 px-2 py-1 rounded w-12 text-center">
                {word.type}
              </span>
            </div>
            <div className={`w-5 h-5 rounded-full flex items-center justify-center ${
              word.selected ? `bg-${word.color}-500 text-white` : 'bg-gray-100'
            }`}>
              {word.selected && <i className="fa-solid fa-check text-xs"></i>}
            </div>
          </div>
        </div>
      ))}
    </div>

            <p className="text-gray-500 text-sm">
              已选择: <span className="font-medium">{selectedWordsCount}</span> 个单词 (来自{selectedUnitsFromWords}个单元)
            </p>
          </div>
        </div>

             {/* Dictation Settings */}
        <div className="mb-8">
          <h3 className="font-bold text-lg mb-3">听写设置</h3>
          <div className="bg-white rounded-xl shadow-sm">
            <div className="p-3 border-b border-gray-100 flex justify-between items-center">
              <div className="font-medium">单词重复次数</div>
              <NumberAdjuster 
                value={localSettings.repeatCount}
                unit="次"
                onDecrease={() => handleSettingChange('repeatCount', Math.max(1, localSettings.repeatCount - 1))}
                onIncrease={() => handleSettingChange('repeatCount', Math.min(5, localSettings.repeatCount + 1))}
              />
            </div>
            <div className="p-3 border-b border-gray-100 flex justify-between items-center">
              <div className="font-medium">重复间隔时间</div>
              <NumberAdjuster 
                value={localSettings.repeatInterval}
                unit="秒"
                onDecrease={() => handleSettingChange('repeatInterval', Math.max(1, localSettings.repeatInterval - 1))}
                onIncrease={() => handleSettingChange('repeatInterval', Math.min(10, localSettings.repeatInterval + 1))}
              />
            </div>
            <div className="p-3 border-b border-gray-100 flex justify-between items-center">
              <div className="font-medium">单词间隔时间</div>
              <NumberAdjuster 
                value={localSettings.wordInterval}
                unit="秒"
                onDecrease={() => handleSettingChange('wordInterval', Math.max(1, localSettings.wordInterval - 1))}
                onIncrease={() => handleSettingChange('wordInterval', Math.min(10, localSettings.wordInterval + 1))}
              />
            </div>
            
            {/* 添加听写顺序设置 */}
            <div className="p-3 border-b border-gray-100 flex justify-between items-center">
              <div className="font-medium">听写顺序</div>
              <div className="flex items-center">
                <button 
                  className={`px-3 py-1 rounded-l-lg text-sm border ${!localSettings.randomOrder ? 'bg-blue-500 text-white border-blue-500' : 'bg-white text-gray-700 border-gray-300'}`}
                  onClick={() => handleSettingChange('randomOrder', false)}
                >
                  选择顺序
                </button>
                <button 
                  className={`px-3 py-1 rounded-r-lg text-sm border ${localSettings.randomOrder ? 'bg-blue-500 text-white border-blue-500' : 'bg-white text-gray-700 border-gray-300'}`}
                  onClick={() => handleSettingChange('randomOrder', true)}
                >
                  随机顺序
                </button>
              </div>
            </div>
            
            {/* 添加试听按钮 */}
            <div className="p-3 flex justify-between items-center">
              <div className="font-medium">测试语音</div>
              <button 
                className="bg-blue-50 text-blue-600 px-3 py-1 rounded-lg text-sm"
                onClick={handleTestVoice}
              >
                <i className="fa-solid fa-volume-high mr-1"></i>
                点击播放
              </button>
            </div>
          </div>
        </div>

        {/* Start Button */}
        <button 
          className="w-full bg-blue-500 text-white py-4 rounded-xl font-bold text-lg shadow-md flex items-center justify-center"
          onClick={handleStartDictation}
        >
          <i className="fa-solid fa-play mr-2"></i>
          开始听写
        </button>
      </div>
        {/* 添加筛选模态框 */}
        <FilterModal />
        {/* 选择模态框 */}
        <SelectionModal 
            isOpen={modal.isOpen}
            onClose={closeModal}
            {...getModalProps()}
        />
    </div>
  );
};

export default ManualSelection;